import React, {useContext} from 'react'
import {Context} from '../../../context/app-context'

import './termsContainer.scss'
import {termsCountry} from "../../../constants/activity-constants";

const TermsContainer = () => {
  const {dispatch} = useContext(Context)

  const onTerms = () => {
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'terms',
        props: {
          close: () => {
            dispatch({type: 'clear-modal'})
          },
          onFinish: () => {

          }
        },
      },
    })
  }


  return (
    <div className="f-terms-container">
      <p className="f-terms-container__text">
        CONOCE LOS <a target='_blank' href={termsCountry} >TÉRMINOS Y CONDICIONES</a> DE EMBAJADORAS
        {/*CONOCE LOS <a onClick={onTerms}>TÉRMINOS Y CONDICIONES</a> DE EMBAJADORAS*/}
      </p>
    </div>
  )
}

export default TermsContainer
